<template>
  <div class="img-frame" v-if="imgSrc">
    <img :src="imgSrc" @error="noFind()" fit="cover"/>
  </div>
</template>

<script setup>
import { ref, watch, defineProps } from 'vue'
const props = defineProps({
  src: String,
  type: {
    type: String,
    default: 'xituan' // xituan-商家、店铺、商品、物品等默认图片 avatar-各种人员的默认头像
  }
})
const imgSrc = ref('')
watch(
  () => props.src,
  newVal => {
    imgSrc.value = newVal || 'https://img.xituan.cn/default/default_xituan.jpg'
  },
  {
    immediate: true
  }
)
const noFind = () => {
  if (props.type == 'avatar') {
    imgSrc.value = 'https://img.xituan.cn/default/default_avatar.jpg'
  } else {
    imgSrc.value = 'https://img.xituan.cn/default/default_xituan.jpg'
  }
}
</script>

<style lang="less" scoped>
.img-frame {
  img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    object-fit: cover;
  }
}
</style>
